import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import FaqForm from "./AddFaq";

export default function EditFaq() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <FaqForm
      isEdit={true}
      faqId={id}
      onSuccess={() => navigate("/listfaq")}
    />
  );
}